(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fly-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fly-product-reviews')) {
    customElements.define('fly-product-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fly-reviews__track');
        if (!this.track) return;
        this.cards = Array.from(this.track.children);
        this.controls = this.querySelector('.fly-reviews__controls');
        this.dots = this.querySelector('.fly-reviews__dots');
        this.pageCount = this.querySelector('.fly-reviews__page-count');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous.addEventListener('click', () => this.go(this.active - 1), options);
        this.next.addEventListener('click', () => this.go(this.active + 1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.fly-reviews__card');
          if (card) this.track.scrollTo({ left: this.position(card), behavior: 'instant' });
        }, options);
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this.track);
        this.build();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      position(card) {
        return card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      }
      build() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const step = Number(getComputedStyle(this.track).getPropertyValue('--fr-columns')) || 1;
        const points = [0];
        for (let index = step; index < this.cards.length; index += step) {
          const point = Math.min(this.position(this.cards[index]), max);
          if (point > points[points.length - 1] + 2) points.push(point);
        }
        if (max > points[points.length - 1] + 2) points.push(max);
        this.points = points;
        this.controls.hidden = max <= 2;
        if (this.dots.children.length !== points.length) {
          this.dots.replaceChildren();
          points.forEach((point, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'fly-reviews__dot';
            button.setAttribute('aria-label', `${this.dataset.pageLabel} ${index + 1}`);
            button.setAttribute('aria-controls', this.track.id);
            button.addEventListener('click', () => this.go(index));
            this.dots.append(button);
          });
        }
        this.update();
      }
      update() {
        if (!this.points) return;
        this.active = this.points.reduce((best, point, index) =>
          Math.abs(point - this.track.scrollLeft) < Math.abs(this.points[best] - this.track.scrollLeft) ? index : best, 0);
        Array.from(this.dots.children).forEach((button, index) => button.setAttribute('aria-current', String(index === this.active)));
        this.pageCount.textContent = `${this.active + 1} / ${this.points.length}`;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= this.points[this.points.length - 1] - 2;
      }
      go(index) {
        const target = Math.max(0, Math.min(index, this.points.length - 1));
        this.track.scrollTo({ left: this.points[target], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
